var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
export default function fetchWithTimeout(url, opts = {}, timeout = 60000) {
  return __awaiter(this, void 0, void 0, function* () {
    const abortController = new AbortController();
    const {
      signal
    } = abortController;
    const _fetchPromise = fetch(url, Object.assign(Object.assign({}, opts), {
      signal
    }));
    const timer = setTimeout(() => abortController.abort(), timeout);
    try {
      const result = yield _fetchPromise;
      clearTimeout(timer);
      return result;
    } catch (e) {
      clearTimeout(timer);
      throw e;
    }
  });
}